var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"height":"100vh"}},[_c('div',{staticClass:"error-container"},[_c('div',{staticClass:"text-h1 color mb-5"},[_vm._v("¯\\_(ツ)_/¯")]),_c('h1',[_vm._v("Pagina non trovata")]),_c('v-btn',{attrs:{"x-large":"","color":"primary","dark":"","to":"/home"}},[_vm._v(" Torna alla homepage ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }